import o from "./floatWindow.ce.vue.js";
import { defineAndRegisterElement as t } from "../../utils/register-element.js";
const n = t(o);
export {
  n as initFloatWindow
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/index.js
// module id = 1252
// module chunks = 41